
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loansSeoLanding",
      function () {
        return require("private-next-pages/loansSeoLanding/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loansSeoLanding"])
      });
    }
  